import { NavList } from "@/utils/constants";
import React from "react";
import NavListItem from "./NavListItem";

const NavbarList = () => {
  return (
    <div className="flex gap-5 items-center px-1 w-full justify-center">
      {NavList.map((item) => (
        <NavListItem key={item.id} {...item} />
      ))}
    </div>
  );
};

export default NavbarList;
